import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Tabs,
  Tab,
  Paper,
  Button,
  Link as MuiLink
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import GavelIcon from '@mui/icons-material/Gavel';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import { PRIVACY_POLICY, TERMS_OF_USE } from '../constants/legalTexts';

function LegalSection({ id, title, icon, content }) {
  return (
    <Paper
      id={id}
      elevation={0}
      sx={{
        p: { xs: 2.5, md: 4 },
        mb: 4,
        borderRadius: 3,
        border: '1px solid #e5e7eb',
        scrollMarginTop: 96
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
        {icon}
        <Typography variant="h5" component="h2" sx={{ fontWeight: 800, color: '#0f172a' }}>
          {title}
        </Typography>
      </Box>
      <Typography
        component="pre"
        sx={{
          whiteSpace: 'pre-wrap',
          fontFamily: 'inherit',
          fontSize: { xs: '0.95rem', md: '1rem' },
          lineHeight: 1.75,
          color: '#334155',
          m: 0
        }}
      >
        {content}
      </Typography>
    </Paper>
  );
}

export default function LegalPage() {
  const [tab, setTab] = useState(0);

  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash === 'privacidade') {
      setTab(1);
      setTimeout(() => {
        document.getElementById('privacidade')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    } else if (hash === 'termos') {
      setTab(0);
      setTimeout(() => {
        document.getElementById('termos')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }, []);

  const handleTabChange = (_, value) => {
    setTab(value);
    const targetId = value === 0 ? 'termos' : 'privacidade';
    window.history.replaceState(null, '', `#${targetId}`);
    setTimeout(() => {
      document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc' }}>
      <Box
        sx={{
          background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
          color: '#fff',
          py: { xs: 4, md: 5 },
          px: 2
        }}
      >
        <Container maxWidth="md">
          <Typography variant="overline" sx={{ opacity: 0.9, letterSpacing: 1.2 }}>
            All Delivery
          </Typography>
          <Typography variant="h3" component="h1" sx={{ fontWeight: 800, mt: 0.5, fontSize: { xs: '1.75rem', md: '2.25rem' } }}>
            Política de Privacidade e Termos de Uso
          </Typography>
          <Typography sx={{ mt: 1.5, opacity: 0.95, maxWidth: 640 }}>
            Documentos legais do aplicativo All Delivery. Leia atentamente antes de utilizar a plataforma.
          </Typography>
          <Button
            component={RouterLink}
            to="/"
            variant="outlined"
            sx={{
              mt: 2.5,
              color: '#fff',
              borderColor: 'rgba(255,255,255,0.6)',
              '&:hover': { borderColor: '#fff', bgcolor: 'rgba(255,255,255,0.08)' }
            }}
          >
            Voltar ao site
          </Button>
        </Container>
      </Box>

      <Container maxWidth="md" sx={{ py: { xs: 3, md: 4 } }}>
        <Paper
          elevation={0}
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 10,
            mb: 3,
            borderRadius: 2,
            border: '1px solid #e5e7eb',
            bgcolor: '#fff'
          }}
        >
          <Tabs
            value={tab}
            onChange={handleTabChange}
            variant="fullWidth"
            sx={{
              '& .MuiTab-root': { fontWeight: 700, textTransform: 'none', fontSize: '0.95rem' },
              '& .Mui-selected': { color: '#059669 !important' },
              '& .MuiTabs-indicator': { bgcolor: '#10B981', height: 3 }
            }}
          >
            <Tab icon={<GavelIcon />} iconPosition="start" label="Termos de Uso" />
            <Tab icon={<PrivacyTipIcon />} iconPosition="start" label="Política de Privacidade" />
          </Tabs>
        </Paper>

        <LegalSection
          id="termos"
          title="Termos de Uso"
          icon={<GavelIcon sx={{ color: '#10B981' }} />}
          content={TERMS_OF_USE}
        />

        <LegalSection
          id="privacidade"
          title="Política de Privacidade"
          icon={<PrivacyTipIcon sx={{ color: '#10B981' }} />}
          content={PRIVACY_POLICY}
        />

        <Box sx={{ textAlign: 'center', py: 3, color: '#64748b' }}>
          <Typography variant="body2">
            Dúvidas? Entre em contato:{' '}
            <MuiLink href="mailto:edleyjoao@gmail.com" sx={{ color: '#059669', fontWeight: 600 }}>
              edleyjoao@gmail.com
            </MuiLink>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
